<section class="body-sign">
    <div class="center-sign">
        <a href="/" class="logo w-100 text-center d-block">
            <img src="assets/img/logo.png" height="44" alt="Comply365" />
        </a>

        <div class="panel card-sign">

            <h3 class="title text-center text-uppercase font-weight-light my-4">Password confirmation</h3>

            <div class="card-body">
                <error-message [errors]="errors"></error-message>
                <form #passwordConfirmForm="ngForm" (submit)="attemptPasswordConfirmation()">
                    <div class="form-group mb-lg">
                        <label>E-mail Address</label>
                        <input name="email" type="email" class="form-control input-lg" [(ngModel)]="email" required #vemail="ngModel" />
                        <div *ngIf="vemail.errors && (vemail.dirty || vemail.touched || submitAttempt)">
                            <label class="error" [hidden]="!vemail.errors.required">Email is a required field.</label>
                        </div>
                    </div>
                    <div class="form-group mb-none">
                        <div class="row">
                            <div class="col-sm-6 mb-lg">
                                <label>Password</label>
                                <input name="pwd" type="password" class="form-control input-lg" required [(ngModel)]="password" #vpassword="ngModel" />
                                <div *ngIf="vpassword.errors && (vpassword.dirty || vpassword.touched || submitAttempt)">
                                    <label class="error" [hidden]="!vpassword.errors.required">Password is a required field.</label>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-lg">
                                <label>Password Confirmation</label>
                                <input name="pwd_confirm" type="password" class="form-control input-lg" required [(ngModel)]="passwordConfirmation" #vpasswordconf="ngModel" />
                                <div *ngIf="vpasswordconf.errors && (vpasswordconf.dirty || vpasswordconf.touched || submitAttempt)">
                                    <label class="error" [hidden]="!vpasswordconf.errors.required">Password confirmation is a required field.</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <button type="submit" class="btn btn-primary">Confirm</button>
                        </div>
                    </div>

                </form>

            </div>
        </div>

        <p class="text-center text-muted mt-3 mb-3">&copy; Copyright 2020. All Rights Reserved.</p>
    </div>
</section>

<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'Your password changed successfully!'">
</app-alert-message>
